"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformData = void 0;
const transformData = (apiData) => {
    const transformedData = [];
    for (let i = 0; i < apiData.length; i++) {
        // Transform data
        const { ID, Sentinel, Project, ProjectStatus, TargetItem, TriggerTS, TriggerType, TriggerObjectID, ProgramEventType, ActionDefID, ActionType, Name, Status, StartTime, PrimaryAssigneeID, ApproverID, DueDate, PendingAcknowledgementIDs, RelevantUserIDs, Operations, } = apiData[i];
        const actionType = JSON.parse(ActionType);
        const project = JSON.parse(Project);
        const triggerType = JSON.parse(TriggerType);
        const programEventType = ProgramEventType ? JSON.parse(ProgramEventType) : {};
        const status = JSON.parse(Status);
        const targetItem = JSON.parse(TargetItem);
        const item = {
            itemName: targetItem.Name,
            itemID: targetItem.ID,
            itemTypeID: targetItem.ItemTypeID,
            abbreviation: targetItem.Abbreviation,
        };
        transformedData.push({
            name: Name,
            actionType: ((actionType === null || actionType === void 0 ? void 0 : actionType.ID) || 0),
            actionTypeName: ((actionType === null || actionType === void 0 ? void 0 : actionType.Name) || ''),
            approverID: ApproverID,
            pendingAcknoledgementIDs: PendingAcknowledgementIDs,
            primaryAssigneeID: PrimaryAssigneeID,
            projectName: (project.Name || ''),
            triggerType: (triggerType.Name || ''),
            programEventName: (programEventType.Name || ''),
            item,
            statusID: status.ID,
            notificationID: ID,
            triggerTimestamp: new Date(`${TriggerTS} UTC`),
            dueDate: DueDate ? (new Date(DueDate)) : undefined,
            operations: Operations,
        });
    }
    return transformedData;
};
exports.transformData = transformData;
